import React from "react";
import Navbar from "./components/Header";
import HomePage from "./components/HomePage";
import SkillSet from "./components/SkillSet";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import About from "./components/About";


import "./App.css";

function App() {
  return (
    <div className="App">
      <Navbar />
      <HomePage />
      <About/>
      <SkillSet />
      <Projects />

      <Contact />
    </div>
  );
}

export default App;
